import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import NewChatButton from "@/components/layout/NewChatButton";
import UsersAdmin from "@/components/users-admin/UsersAdmin";

const AdminUsersPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Manage which users can create public share links. Sharing is enabled by default for every user; disable it here to revoke an individual user's access."
      actions={<NewChatButton />}
    >
      User Share Access
    </Header>
    <UsersAdmin />
  </SpaceBetween>
);

export default AdminUsersPage;
